var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNetLiquidityRatio = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.792 0H2.65407C1.18697 0 -0.000610352 1.23 -0.000610352 2.7495V18.249C-0.000610352 19.77 1.18697 21 2.65407 21H9.1713V15C9.1713 14.9205 9.1713 14.8395 9.19013 14.7705C9.19013 14.751 9.20027 14.73 9.20027 14.7105C8.73682 14.8605 8.24441 14.97 7.72303 14.97C6.65131 14.97 5.65634 14.61 4.86559 13.9905L8.23572 10.5C8.37041 10.3605 8.44862 10.17 8.44862 9.97048V5.03099C10.776 5.39099 12.5516 7.47149 12.5516 9.97048C12.5516 10.431 12.4748 10.86 12.359 11.28C12.3691 11.28 12.3778 11.2695 12.3879 11.2695C13.267 10.92 14.2996 10.68 15.4481 10.5795V2.7495C15.4481 1.23 14.2605 0 12.792 0ZM6.99889 9.65998L3.84166 12.93C3.24352 12.1095 2.89594 11.0805 2.89594 9.97048C2.89594 7.46999 4.67297 5.39099 6.99889 5.03099V9.65998Z",
    fill: "#00D2A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8978 16.999C20.3636 16.999 23.1732 16.1038 23.1732 14.9995C23.1732 13.8952 20.3636 13 16.8978 13C13.432 13 10.6224 13.8952 10.6224 14.9995C10.6224 16.1038 13.432 16.999 16.8978 16.999Z",
    fill: "#6C7DE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8978 20.4994C20.3635 20.4994 23.1732 19.6039 23.1732 18.4999V17.2324C21.1977 18.4144 17.7972 18.4999 16.8978 18.4999C15.9984 18.4999 12.5979 18.4144 10.6224 17.2324V18.4999C10.621 19.6039 13.4306 20.4994 16.8978 20.4994Z",
    fill: "#6C7DE5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8976 21.9999C15.9982 21.9999 12.5976 21.9144 10.6222 20.7324V21.9999C10.6222 23.1039 13.4318 23.9994 16.8976 23.9994C20.3633 23.9994 23.1729 23.1039 23.1729 21.9999V20.7324C21.1975 21.9129 17.7969 21.9999 16.8976 21.9999Z",
    fill: "#6C7DE5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNetLiquidityRatio);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/net_liquidity_ratio.8c3b4313f471d3901604663faae366df.svg";